/* global Razorpay*/
import React, { useState } from 'react';
import SubHeader from '../general/SubHeader';
import Donation1 from '../assets/helping-1.jpg';

const Donation = () => {

  const [donationForm, setDonationForm] = useState(false);
  const [cause, setCause] = useState('');
  const [pricePerPerson, setPricePerPerson] = useState(0);
  const [error, setError] = useState('');
  const [donationAmount, setDonationAmount] = useState('');
  const [numberOfPeople, setNumberOfPeople] = useState(1);

  const handleDonation = (causeName, price) => {
    setCause(causeName);
    setPricePerPerson(price); // Set the price per person for the selected cause
    setDonationForm(true);
    setError('');
    setDonationAmount(Number(price)); // Default donation amount for 1 person
    setNumberOfPeople(1); // Reset number of people to 1 by default
  }


  // Function to generate order ID in frontend
  // const generateOrderId = () => {
  //   return `ORD-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
  // };

  const handleCheckout = async (e) => {
    e.preventDefault(); // Prevent form submission
    if (parseFloat(donationAmount) <= 100) {
      setError('Donation amount must be more than 100.');
    } else {
      setError('');

      // const orderId = generateOrderId();
      // console.log(orderId);

      try {
        const response = await fetch('https://apis.anvifoundation.com/anvi/create-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ amount: donationAmount, currency: 'INR' }),
        });

        const data = await response.json();
        const orderId = data.order_id;

        // Proceed to the payment page
        const options = {
          key: "rzp_live_HsO4wSHFOXAH0F", // Enter your Razorpay Key ID here
          amount: donationAmount * 100, // Amount in paise (1 INR = 100 paise)
          currency: "INR",
          name: "Anvi Jan Kalyan Trust", // Your business name
          description: `Donation for ${cause}`,
          image: "../src/assets/logo.jpeg", // Your logo URL
          order_id: orderId, // Replace with the dynamic order ID you get from your backend
          prefill: {
            name: e.target.name.value, // Get the name from the form input
            email: e.target.email.value, // Get the email from the form input
            contact: e.target.phone.value, // Get the contact from the form input
          },
          notes: {
            address: "Razorpay Corporate Office",
          },
          theme: {
            color: "#3399cc", // Customize your theme color
          },
          handler: function (response) {
            alert("Payment Successful! Payment ID: " + response.razorpay_payment_id);
            // Here, you can also send the response data to your backend to confirm the payment

            // Send donation data to backend after successful payment
            const donationData = {
              name: e.target.name.value,
              email: e.target.email.value,
              phone: e.target.phone.value,
              cause: cause,
              amount: donationAmount,
              numberOfPeople: numberOfPeople,
              paymentId: response.razorpay_payment_id, // Payment ID from Razorpay response
              status: 'success' // Payment status
            };

            // Make an API call to the backend to store donation details
            fetch('https://apis.anvifoundation.com/anvi/save-donation', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(donationData),
            })
              .then((response) => response.json())
              .then((data) => {
                console.log('Donation saved successfully:', data);
                alert('Thank you for your donation!');
              })
              .catch((error) => {
                console.error('Error saving donation:', error);
                // alert('Something went wrong. Please try again later.');
              });
          },
          modal: {
            ondismiss: function () {
              alert("Payment process was cancelled.");
            }
          }
        };

        var rzp1 = new Razorpay(options);
        rzp1.open(); // Open the Razorpay payment modal
        console.log('Proceeding to payment...');
      }
      catch (error) {
        console.error('Error fetching order ID:', error);
      }
    }
  }

  const handleNumberOfPeopleChange = (e) => {
    const numPeople = e.target.value;
    setNumberOfPeople(numPeople);
    setDonationAmount(numPeople * pricePerPerson); // Update donation amount based on number of people
  };


  return (
    <>
      <SubHeader message='Donation Causes' />

      {/* Donation causes */}
      <section className='my-5'>
        <div className='container'>


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Namami Gange Mission</p>
                <hr />
                <p>स्वच्छ गंगा के लिए राज्य मिशन-उत्तर प्रदेश के विसन में "अविरल धारा" (निरंतर प्रवाह"), "निर्मल धारा" ("प्रदूषण रहित प्रवाह"), भूगर्भिक और पारिस्थितिक अखंडता सुनिश्चित करने के संदर्भ में परिभाषित नदी की पूर्णता को बहाल करना शामिल है।<br /><br />
                  By supporting these causes, donors actively combat water pollution and contribute to a healthier environment, fostering sustainable access to vital water resources.</p>

                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Reduce water pollution<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Promote Community Health<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Safe drinking water for future generations<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Save marine life</p>

                <button className='donate-btn' onClick={() => handleDonation("Namami Gange Mission", 200)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>


          </div>
          {/* row 1 ends */}


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted order-first order-lg-last'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Clothes for Everyone</p>
                <hr />
                <p>जरुरतमंदो तक कपड़े पहुचाने मे हमारी मदद करे ।<br /><br />
                  Every donation, big or small, can bring hope and a positive change. Your financial donations help us to purchase clothes based on current needs, including specific sizes, seasonal
                  clothing, or specialized items for people.<br />
                  These donation help in emergency situations, where we can immediately buy and distribute clothing to areas affected by disaster, poverty, or crisis.</p>

                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Support Long term initiative<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Help distribute clothing<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Fulfill basic needs</p>

                <button className='donate-btn' onClick={() => handleDonation("Donation for Clothes", 150)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>


          </div>
          {/* row 2 ends */}


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Plantation Project</p>
                <hr />
                <p>पेड़ लगाये और वातवरण को स्वच्छ बनाए ।<br /><br />
                  Monetary donations allow charities to plant more trees efficiently, as funds can be allocated to large-scale planting projects, increasing the number of trees that can be planted in deforested or degraded areas.<br />
                  Your donations help our foundation that involve local communities in tree planting & providing jobs.</p>

                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Promote environmental awareness<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Help combat climate change<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Safe drinking water for future generations<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Save marine life</p>

                <button className='donate-btn' onClick={() => handleDonation("Donation for Plant", 400)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>


          </div>
          {/* row 3 ends */}

          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted order-first order-lg-last'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Help to provide food</p>
                <hr />
                <p>आप दान करके किसी भूखे व्यक्ति को भोजन करा सकते है ।<br /><br />
                  With financial contributions, our foundation can smake more efforts, ensuring a larger number of people in
                  poor communities receive essential meals, improving overall well-being and health.<br />
                  Your donation can support our long-term food assistance programs, helping to establish consistent food distribution systems.</p>

                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Provide free meals<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Promote Poor Health & Well being<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Help to survive</p>

                <button className='donate-btn' onClick={() => handleDonation("Donation for Food", 300)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>


          </div>
          {/* row 4 ends */}


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Beti Bachao, Beti Padhao</p>
                <hr />
                <p>महिलाओं एवं बालिकाओं की शिक्षा व उन्हें आत्मनिर्भर बनाने मे योगदान करे ।<br /><br />
                  This initiative aims at promoting gender equality, preventing female infanticide, and ensuring education for girls.
                  We ensure her right to education, healthcare, and equal opportunities. The program focuses on empowering girls and encouraging their overall development.</p>

                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Gender equality promotion<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Combating female foeticide<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Encouraging girl education<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Empowering women and communities</p>

                <button className='donate-btn' onClick={() => handleDonation("Beti Bachao, Beti Padhao", 1500)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>


          </div>
          {/* row 5 ends */}


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted order-first order-lg-last'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Clean India, Green India</p>
                <hr />
                <p>हम पर्यावरण, वन और पशु समस्याओं से निपटने के लिए वन विकास और इसके परिधीय क्षेत्रों के बेहतर समन्वय के लिए पूरक योजनाओं और कार्यक्रमों पर
                  एक व्यापक और टिकाऊ तरीके से अभिसरण करना चाहते है।<br /><br />
                  This is aimed at improving sanitation, promoting waste management, and encouraging environmental conservation. It
                  strives to create a cleaner, healthier environment by focusing on cleanliness, tree plantation, and reducing
                  pollution.</p>


                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Sanitation and cleanliness<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Waste management and recycling<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Tree plantation and green spaces<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Pollution reduction and awareness</p>

                <button className='donate-btn' onClick={() => handleDonation("Clean India, Green India", 700)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>


          </div>
          {/* row 6 ends */}


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Free Medical/ Yoga Camp</p>
                <hr />
                <p>जरुरतमंदो तक फ्री हेल्थ चेकप और दवाइया पहुचाने मे मदद करे ।<br /><br />
                  We offer healthcare services and wellness practices to improve physical and mental health. The initiative provides free
                  consultations, treatments, and yoga sessions to promote overall well-being in communities, particularly for
                  underprivileged groups, fostering a healthier lifestyle and encouraging preventive care.</p>


                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Free medical consultations<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Health check-ups and treatments<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Yoga and wellness sessions<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Community health awareness</p>

                <button className='donate-btn' onClick={() => handleDonation("Medical camp", 500)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>

          </div>
          {/* row 7 ends */}


          <div className='row donation-area my-4'>

            <div className='col-lg-5 col-12 my-2 text-muted order-first order-lg-last'>
              <div className='rounded-start-4 activity-bg py-4 px-4 h-100'>
                <p className='sec-heading5'>Women Empowerment</p>
                <hr />
                <p>औरतो को विभिन्न कला सिखाने मे योगदान दे जिससे उन्हे आसानी से रोजगार मिल सके ।<br /><br />
                  Our foundation focuses on enhancing women's social, economic, and political status, ensuring equal rights and
                  opportunities. It aims to reduce gender inequality, encourage education, and provide women with the resources to lead
                  independent, successful lives, fostering a more inclusive society.</p>

                <p className='fst-italic'><i class="fa-solid me-2 fa-ribbon"></i>Gender equality<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Education and skill development<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Economic independence<br />
                  <i class="fa-solid me-2 fa-ribbon"></i>Political participation and leadership</p>

                <button className='donate-btn' onClick={() => handleDonation("Women Empowerment", 200)}>Donate Now</button>
              </div>
            </div>

            <div className='col-lg-7 col-12 my-2 ps-lg-0'>
              <div className='row'>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                <div className='col-6'>
                  <img src={Donation1} className='img-fluid' alt='Clean Water' /></div>
                {/* <img src={Donation1} className='img-fluid col-4' alt='Clean Water' /> */}
              </div>
              {/* inner row ends */}
            </div>

          </div>
          {/* row 8 ends */}


        </div>
      </section>
      {/* Donation causes ends */}


      {donationForm && (
        <section className='job-form'>
          <div className='container job-form-inner text-end'>

            <button className='close-btn' onClick={() => setDonationForm(false)}>
              <i className="fa-solid fa-xmark"></i>
            </button>

            <div className='text-center'>
              <p className='sec-heading5'>Donate Now</p>

              <form class="row g-3 px-lg-4 px-md-2 px-0 mt-3 text-start" onSubmit={handleCheckout}>
                <div class="col-12">
                  <input type="text" class="form-text" id="inputName" name='name' placeholder='Name' required />
                </div>

                <div class="col-12">
                  <input type="text" class="form-text" id="inputCause" name='cause' value={cause} placeholder='Donating For' disabled required />
                </div>

                <div class="col-md-6">
                  <input type="text" class="form-text" id="inputEmail" name='email' placeholder='Email' />
                </div>

                <div class="col-md-6">
                  <input type="tel" class="form-text" id="inputPhone" name='phone' placeholder='Phone' required />
                </div>

                <div className="col-12">
                  <label for="Donation Amount" className='fst-italic'>{cause}/ Person</label>
                  <input
                    type="number"
                    className="form-text"
                    id="inputPeople"
                    name='people'
                    value={numberOfPeople}
                    onChange={handleNumberOfPeopleChange}
                    placeholder='Number of People'
                    min="1"
                    required
                  />
                </div>

                <div className="col-12">
                  <label for="Donation Amount" className='fst-italic'>Donation Amount</label>
                  <input
                    type="text"
                    className="form-text"
                    id="inputDonation"
                    name='donation'
                    placeholder='Donation Amount'
                    value={donationAmount}
                    disabled
                  />
                  {error && <div className="text-danger text-start">{error}</div>}
                </div>


                <div class="col-12">
                  <button type="submit" class="donate-btn w-100">Proceed to Pay</button>
                </div>

              </form>

            </div>

          </div>
        </section>

      )}


    </>
  )
}

export default Donation
